type LiveStatusChipProps = {
    isLive: boolean;
    /** Shown in place of "Paused" when not live, e.g. "Showing selected date range". */
    pausedLabel?: string;
    /** Announced to screen readers when the state changes; falls back to the visible label. */
    srMessage?: string;
};

/**
 * The green pulsing "Live" / grey "Paused" pill. Extracted from FacilityLiveView, which had it
 * inline, so the Parking View's tables can say the same thing the same way — a feed that updates
 * itself should look identical wherever it appears.
 */
export const LiveStatusChip: React.FC<LiveStatusChipProps> = ({ isLive, pausedLabel = "Paused", srMessage }) => (
    <>
        <span
            role="status"
            className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-semibold normal-case ${isLive ? "bg-green-100 text-green-700" : "bg-gray-200 text-gray-600"}`}
        >
            <span className={`w-2 h-2 rounded-full ${isLive ? "bg-green-500 animate-pulse" : "bg-gray-400"}`} />
            {isLive ? "Live" : pausedLabel}
        </span>
        <span aria-live="polite" className="sr-only">
            {srMessage ?? (isLive ? "Live updates active." : `Live updates paused. ${pausedLabel}.`)}
        </span>
    </>
);
